import { useContext } from "react"
import { AppContext } from "../../context/AppContext"
import axios from 'axios';
import {
  Tooltip,
	IconButton,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import GeoJSON from 'ol/format/GeoJSON';
import { cql2filter } from '../../common/func/cql2filter'
import { abstractFetch } from "../../common/func/abstractFetch";

export default function BottomBox(props) {
  const { step, mapMode, execFunctionLog } = useContext(AppContext);

  const onClickFlowIndexBtn = async () => {
		if(props.target.mapMode1 === 'out') {
			execFunctionLog('유입 중심성 지수별 거점 분석', '유입 중심성 지수 설정 및 분석 기능 제공');
		} else if(props.target.mapMode1 === 'in') {
			execFunctionLog('유출 중심성 지수별 거점 분석', '유출 중심성 지수 설정 및 분석 기능 제공');
		};
		
		const fetchXmlString = async () => {
			const indexXmlString = await cql2filter(
				'pc_' + props.target.mapMode1 + '_val>=' + props.flowIndex
			);

			const indexFeatureRequest = {
				service: 'WFS',
				version: '1.0.0',
				request: 'GetFeature',
				outputFormat: 'application/json',
				srsName: 'EPSG:3857',
				typeName: 'pinogio:flow_pc_grid_2021',
				filter: indexXmlString,
			}; 

			abstractFetch(indexFeatureRequest)
				.then((res) => {
					props.flowLayers.centralHubV.getSource().clear();
					props.flowLayers.centralHubV
						.getSource()
						.addFeatures(new GeoJSON().readFeatures(res));
				})
				.catch((err) => console.log(err));
	
			props.flowLayers.centralHubV.getSource().refresh();
			props.flowLayers.centralHubV.setVisible(true);
	
			props.flowLayers.centralHubT
				.getSource()
				.updateParams({ filter: await cql2filter(`pc_${props.target.mapMode1}_val>=${props.flowIndex}`) });
			props.flowLayers.centralHubT.getSource().refresh();
			props.flowLayers.centralHubT.setVisible(true);
		}
		fetchXmlString();
	};

  return (
    <div>
      {step === 1 && mapMode !== `${props.target.mapMode2}` ? (
						<div className="bottomInfoBox">
							<div className="mapSelectWrap densityBarWrap">
								<div className="barWrapTit">
									<h4 className="boxTit">{props.target.name} 중심성 지수 입력하기</h4>
									<Tooltip
										title={`${props.target.name} 중심성 지수를 입력하면 해당 값 이상의 격자(들)만 나타납니다. 입력 가능한 ${props.target.name} 중심성 지수 값의 범위는 0 이상 ${props.target.max1} 이하입니다. 기본으로 입력된 ${props.target.base} 전국 기준 상위 20%에 해당하는 값입니다.`}
										className="infoTooltip"
									>
										<IconButton size="small">
											<InfoIcon className="infoTooltipIcon"></InfoIcon>
										</IconButton>
									</Tooltip>
									<div className="detail info1">
										<span>※ 전국 통계</span>
										<div>
											<ul>
												<li>평균: {props.target.average}</li>
												<li>최솟값: 0</li>
											</ul>
											<ul>
												<li>중위수: {props.target.medium}</li>
												<li>최댓값: {props.target.max2}</li>
											</ul>
										</div>
									</div>
								</div>
								<div>
									<input
										className={`densityNum ${props.target.textColor}`}
										type="number"
										step={0.001}
										min={0.0}
										max={props.max}
										value={props.flowIndexInput}
										onChange={props.handleFlowIndexInput}
									/>
									<span>이상</span>
									<button
										className={`searchBtn ${props.target.colorBox}`}
										onClick={onClickFlowIndexBtn}
									>
										선택
									</button>
									<div className="detail info2">
										<span>* 0 이상 {props.target.max1} 이하 값 입력 가능</span>
									</div>
								</div>
							</div>
						</div>
					) : // bottomInfoBox
					null}
    </div>
  )
}